import React from "react";
import { formatCurrencyCOP, formatDate } from "../utils/format";

function EntriesModal({ data, title, onClose }) {
  const handleOverlayClick = () => {
    onClose();
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex items-start justify-center z-50"
      onClick={handleOverlayClick}
    >
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-7xl p-6 mt-6"
        onClick={handleContentClick}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-red-500 text-2xl font-bold"
          >
            &times;
          </button>
        </div>

        <div className="w-full overflow-x-auto rounded-xl shadow">
          <table className="w-full table-auto border-collapse">
            <thead>
              <tr className="bg-gray-100 text-gray-700 text-sm uppercase tracking-wider text-center">
                <th className="px-4 py-3 whitespace-nowrap">Marca</th>
                <th className="px-4 py-3 whitespace-nowrap">Presentación</th>
                <th className="px-4 py-3 whitespace-nowrap">Invima</th>
                <th className="px-4 py-3 whitespace-nowrap">Lote</th>
                <th className="px-4 py-3 whitespace-nowrap">Fecha Venc.</th>
                <th className="px-4 py-3 whitespace-nowrap">Cantidad</th>
                <th className="px-4 py-3 whitespace-nowrap">Ingreso</th>
                <th className="px-4 py-3 whitespace-nowrap">Proveedor</th>
              </tr>
            </thead>

            <tbody className="text-center">
              {data.length === 0 ? (
                <tr>
                  <td
                    colSpan="8"
                    className="px-6 py-6 text-gray-400 italic"
                  >
                    No hay registros.
                  </td>
                </tr>
              ) : (
                data.flatMap((item, index) =>
                  item.entry_details.map((detail, i) => (
                    <tr
                      key={`${item.id}-${i}`}
                      className={`border-t ${
                        (index + i) % 2 === 0 ? "bg-white" : "bg-gray-50"
                      }`}
                    >
                      <td className="px-4 py-3">
                        {detail.variant?.brand?.name || "N/A"}
                      </td>
                      <td className="px-4 py-3">
                        {detail.variant?.presentation?.name || "N/A"}
                      </td>
                      <td className="px-4 py-3">
                        {detail.variant?.invima_code || "N/A"}
                      </td>
                      <td className="px-4 py-3">
                        {detail.variant?.batch_number || "N/A"}
                      </td>
                      <td className="px-4 py-3">
                        {detail.variant?.expiration_date
                          ? formatDate(detail.variant.expiration_date)
                          : "N/A"}
                      </td>
                      <td className="px-4 py-3 text-center">
                        {detail.quantity}
                      </td>
                      <td className="px-4 py-3">
                        {formatDate(item.date)}
                      </td>
                      <td className="px-4 py-3">
                        {item.supplier?.name || "N/A"}
                      </td>
                    </tr>
                  ))
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default EntriesModal;
